import { render, staticRenderFns } from "./myLive.vue?vue&type=template&id=e3ec2198&scoped=true"
import script from "./myLive.vue?vue&type=script&lang=js"
export * from "./myLive.vue?vue&type=script&lang=js"
import style0 from "./myLive.vue?vue&type=style&index=0&id=e3ec2198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ec2198",
  null
  
)

export default component.exports